import React from 'react';
import OptimizedImage from '../OptimizedImage';

export default ({
  bg,
  img,
  staticContent: { title, description, stepNumber }
}) => {
  return (
    <div className={`${bg ? 'bg mt-n1' : ''}`}>
      <div className="container">
        <div className={`step ${bg ? 'mt-n2' : 'pt-5 mt-n2'}`}>
          <div className="left-section">
            <div className="number-border">
              <div className="number-step">
                <span>{stepNumber}</span>
              </div>
            </div>
          </div>
          <div className="right-section">
            <div className={`row position-relative ${bg ? 'relative' : ''}`}>
              <div className="col-md-6">
                <h3 className="tt">{title}</h3>
                <p>{description}</p>
              </div>
              {img && (
                <div className="w-50 d-none d-md-block">
                  <OptimizedImage
                    src="our-approach.png"
                    alt="icon"
                    className="dd-lg-block w-100"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
